import {Component, OnInit} from '@angular/core';
import {provideNativeDateAdapter} from '@angular/material/core';
import {BusinessService} from '../../_service/business.service';
import {Business} from '../../models/business.model';

@Component({
  selector: 'app-billing-information',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './billing-information.component.html',
  styleUrl: './billing-information.component.css',
})
export class BillingInformationComponent implements OnInit {
  configList: any;
  business: Business;
  billingType = 'TIMETAP';
  billingUrl: string;
  reloadingBusiness: boolean = false;
  businessCouldNotBeReactivated: boolean = false;
  reactivating: boolean = false;

  constructor(private businessService: BusinessService) {
    this.business = businessService.getBusiness();
    this.configList = this.businessService.getConfigList();
  }

  ngOnInit() {
    if (this.business.billingProcessor === 'TIMETAP') {
      this.billingType = 'TIMETAP';
    } else {
      this.billingType = 'RECURLY';
    }
    this.businessService.getBillingHash().subscribe(value => {
      if (this.billingType === 'RECURLY') {
        this.billingUrl = value.url;
      }
    });
  }
  reloadBusinessToReactivate() {
    this.reloadingBusiness = true;
    this.businessService.getBusinessForUser().subscribe(value => {
      this.business = value;
      this.businessService.setBusiness(value);
      this.reloadingBusiness = false;
    });
  }
  awakeFromHibernate() {
    this.reactivating = true;
    this.businessService.awakeFromHibernate().subscribe(value => {
      this.reactivating = false;
      this.business = value;
      this.businessService.setBusiness(value);
    });
  }
}
